import { fbt } from 'fbtee'
import { Share2, Link } from 'lucide-react'
import { Button } from './ui/button'
import { canNativeShare, copyEventLink, nativeShareEvent } from '../lib/share'
import { cn } from '../lib/utils'

// One-tap share for an event: the native share sheet where the platform offers
// one, a clipboard copy everywhere else. Both paths land on the canonical
// /events/:eventId URL.
export function EventShareButton({
  eventId,
  eventName,
  className,
}: {
  eventId: string
  eventName: string
  className?: string
}) {
  const native = canNativeShare()

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn('size-8', className)}
      onClick={() => (native ? nativeShareEvent(eventId, eventName) : copyEventLink(eventId))}
      aria-label={
        native
          ? fbt('Share event', 'Accessible label for the share event button')
          : fbt('Copy event link', 'Accessible label for the copy event link button')
      }
    >
      {native ? <Share2 className="size-4" /> : <Link className="size-4" />}
    </Button>
  )
}
